import { Check } from "lucide-react";
import type { AvailableApp } from "@/lib/api/controlPlaneClient";
import { cn } from "@/lib/utils";
import { AppLogo } from "./AppLogo";

/**
 * Compact icon + title + subtitle row used in the "new & noteworthy" grid,
 * mirroring Canva's dense discovery list.
 */
export function CompactAppCard({
  app,
  isInstalled,
  onClick,
}: {
  app: AvailableApp;
  isInstalled?: boolean;
  onClick?: (app: AvailableApp) => void;
}) {
  return (
    <button
      type="button"
      onClick={() => onClick?.(app)}
      aria-label={`${app.app_name} — ${app.description}`}
      className={cn(
        "group flex items-center gap-3 rounded-xl p-3 text-left transition-colors",
        "hover:bg-gray-100/70 dark:hover:bg-gray-800/60",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2794F0]"
      )}
    >
      <AppLogo app={app} size={44} radius={12} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <p className="truncate text-sm font-semibold text-gray-900 dark:text-gray-100">
            {app.app_name}
          </p>
          {isInstalled && (
            <Check className="h-3.5 w-3.5 shrink-0 text-green-600" strokeWidth={3} />
          )}
        </div>
        <p className="truncate text-xs text-gray-500 dark:text-gray-400">{app.description}</p>
      </div>
    </button>
  );
}
